import React from 'react'
import "./Technolo.css"
import l1 from "./l1.svg";
import flutter from "./flutter.svg";
import next from "./next.svg";
import javascript from "./javascript.svg";
import node from "./node.svg";
import native from "./native.svg";
import angular from "./angular.svg";
import express from "./express.svg";
import kotlin from "./kotlin.svg";
import python from "./python.svg";
import rails from "./rails.svg";
import django from "./django.svg";
import php from "./php.svg";
import c from "./c.svg";
import cs from "./cs.svg";
import cp from "./cp.svg";
import java from "./java.svg";
import go from "./go.svg";
import wix from './wix.svg';
import shopify from "./shopify.svg";
import wordpress from "./wordpress.svg"
import { Link } from 'react-router-dom';




export default function Technolo() {
  return (
    <div>
      <div className="t" id="techdiv">
      
        {/* <video autoPlay loop muted playsInline className="bg-video__contentt">
          <source src={Videoo} type="video/mp4" />
        </video> */}
        <div className="contentt ">
          <div className=" flex flex-row items-center justify-center ">
          <h3 className="text-gray-800 text-3xl font-semibold sm:text-4xl">
          Development Experts in the<br></br> Most Popular Technologies
                    </h3>
            
           
          </div>
          <hr class="w-48 h-0.5 mx-auto my-4 bg-gray-900 border-0 rounded md:my-10 " />
          {/* here the list of techs starts */}

        
          <div className=" tech flex flex-row items-center justify-center  ">
            <Link  to="/ReactNative">
            
              <img src={native} alt="SVG logo " className="animate__animated animate__rotateIn animate__repeat-2" />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                React Native
              </h4> */}
            
            </Link>
            <button>
              <img src={l1} alt="SVG logo"className='animate__animated animate__rotateIn animate__repeat-2' />
              {/* <h4 class=" font-large leading-tight text-base  mb-2 text-blue-500">
                React.js
              </h4> */}
            </button>
            <button>
              <img className="express animate__animated animate__rotateIn animate__repeat-2" src={express} alt="SVG logo "  />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                Express.js
              </h4> */}
            </button>
          </div>
          <div className=" tech mt-5 flex flex-row items-center justify-center ">
            <button>
              <img src={next} alt="SVG logo " className='animate__animated animate__rotateIn animate__repeat-2' />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                Next.js
              </h4> */}
            </button>

            <button>
              <img src={node} alt="SVG logo " className='animate__animated animate__rotateIn animate__repeat-2' />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                Node.js
              </h4> */}
            </button>
            <button>
              <img src={angular} alt="SVG logo " className='animate__animated animate__rotateIn animate__repeat-2' />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                Angular.js
              </h4> */}
            </button>

            {/* <button>
            <img src={vue} alt="SVG logo " />
            <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
              Vue.js
            </h4>
          </button> */}
          </div>

          <div className="mt-5 tech flex flex-row items-center justify-center   ">
            <button>
              <img src={javascript} alt="SVG logo " className='animate__animated animate__rotateIn animate__repeat-2' />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                javascript
              </h4> */}
            </button>
            <button>
              <img src={flutter} alt="SVG logo " />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                Fluttter
              </h4> */}
            </button>
            <button>
              <img src={python} alt="SVG logo " className='animate__animated animate__rotateIn animate__repeat-2' />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                Python
              </h4> */}
            </button>
          </div>
          <div className="mt-5 tech flex flex-row items-center justify-center ">
            <button>
              <img src={django} alt="SVG logo " className='animate__animated animate__rotateIn animate__repeat-2' />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                django
              </h4> */}
            </button>

            <button>
              <img src={kotlin} alt="SVG logo" viewBox="0 0 24 24" className='animate__animated animate__rotateIn animate__repeat-2' />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                kotlin
              </h4> */}
            </button>
            <button>
              <img src={rails} alt="SVG logo " className='animate__animated animate__rotateIn animate__repeat-2' />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                rails
              </h4> */}
            </button>
          </div>

          <div className="mt-5 tech flex flex-row items-center justify-center ">
            <button>
              <img src={go} alt="SVG logo " className='animate__animated animate__rotateIn animate__repeat-2' />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                Go
              </h4> */}
            </button>
            <button>
              <img src={java} alt="SVG logo " className='animate__animated animate__rotateIn animate__repeat-2' />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                Java
              </h4> */}
            </button>
            <button>
              <img src={php} alt="SVG logo " className='animate__animated animate__rotateIn animate__repeat-2' />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                php
              </h4> */}
            </button>
          </div>

          
          <div className="mt-5 tech flex flex-row items-center justify-center ">
            
            <button>
              <img src={c} alt="SVG logo " className='animate__animated animate__rotateIn animate__repeat-2' />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                C
              </h4> */}
            </button>
            <button>
              <img src={cs} alt="SVG logo " className='animate__animated animate__rotateIn animate__repeat-2' />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                C#
              </h4> */}
            </button>
            <button>
              <img src={cp} alt="SVG logo " className='animate__animated animate__rotateIn animate__repeat-2' />
              {/* <h4 class=" font-large leading-tight text-base mt-0 mb-2 text-blue-500">
                C++
              </h4> */}
            </button>
          </div>
          <div className="mt-5 flex items-center justify-center ">
          
          <h1 class="font-bold leading-tight text-2xl ml-1 mt-0 mb-2 text-gray-900 ">
            CMS Development 
          </h1>
         
        </div>
        <hr class="w-48 h-0.5 mx-auto my-4 bg-gray-900 border-0 rounded md:my-10 " />

          

          <div className="tech mt-5 mb-3 flex flex-row items-center justify-center  ">
            <button>
              <img src={wordpress} alt="SVG logo " className="animate__animated animate__rotateIn animate__repeat-2" />
             
            </button>
            <button>
              <img src={wix} alt="SVG logo"className='animate__animated animate__rotateIn animate__repeat-2' />
              {/* <h4 class=" font-large leading-tight text-base  mb-2 text-blue-500">
                React.js
              </h4> */}
            </button>
            <button>
              <img src={shopify} alt="SVG logo " className="express animate__animated animate__rotateIn animate__repeat-2"   />
             
            </button>
          </div>
        </div>
      </div>

    </div>
  )
}
